import React, { useState } from 'react';
import { BringzzPageContainer, BringzzText, BringzzIcon, BringzzInput, BringzzDate, BringzzButton, BringzzAccordion, BringzzBottomDrawer, BringzzRadioList, BringzzRadio } from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { Mode } from "@bringzz/components";

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const PrescriptionFormPage = () => {
    const { navigate } = useNavigation();

    // Form state
    const [svName, setSvName] = useState('');
    const [svNameDrawerOpened, setSvNameDrawerOpened] = useState(false);
    const [patientName, setPatientName] = useState('');
    const [svNumber, setSvNumber] = useState('');
    const [birthday, setBirthday] = useState(null);
    const [rezId, setRezId] = useState('');
    const [validity, setValidity] = useState(null);
    const [issueDate, setIssueDate] = useState(null);

    // Add this near other state declarations
    const insuranceProviders = [
        "TK (Techniker Krankenkasse)",
        "AOK (Allgemeine Ortskrankenkasse)",
        "BARMER",
        "DAK-Gesundheit",
        "IKK classic",
        "KKH (Kaufmännische Krankenkasse)",
        "HEK (Hanseatische Krankenkasse)",
        "BKK (Betriebskrankenkasse)"
    ];

    const validateForm = () => {
        return Boolean(
            svName.trim() &&
            patientName.trim() &&
            svNumber.trim() &&
            birthday &&
            rezId.trim() &&
            validity &&
            issueDate
        );
    };

    return (
        <BringzzPageContainer
            className="bg-white pb-24"
            header={{
                left: <BringzzIcon
                    icon="IconClose"
                    folder="LineIcons"
                    size="16"
                    className="cursor-pointer"
                    onClick={() => navigate('/basket')}
                />,
            }}
            footer={
                <div className='p-4 space-x-2 flex'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={() => {
                            navigate('/prescription/form/products');
                        }}
                        disabled={!validateForm()}
                    >
                        Continue
                    </BringzzButton>
                    <BringzzButton
                        size='lg'
                        className='bg-white w-full flex justify-center border border-gray-300'
                        onClick={() => navigate('/basket')}
                    >
                        Cancel
                    </BringzzButton>
                </div>
            }
        >
            <div className='p-4 space-y-6'>
                <div className='space-y-4'>
                    <BringzzText tag="h1" className="text-center">Please check your receipt information</BringzzText>
                    <BringzzText tag="h4" className="text-center text-gray-500 font-thin">Please enter the following fields manually so that we can fully read your prescription</BringzzText>
                </div>

                <div className='space-y-4'>
                    <BringzzInput
                        label="SV Name"
                        placeholder={svName || "Select Insurance Provider"}
                        tooltip="Your insurance provider name"
                        readOnly={true}
                        className="cursor-pointer"
                        icon={{
                            right: <BringzzIcon
                                icon="IconChevronDown"
                                library="Custom"
                                className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                size="12"
                            />
                        }}
                        onClick={() => setSvNameDrawerOpened(true)}
                    />

                    <BringzzBottomDrawer
                        isOpen={svNameDrawerOpened}
                        close={() => setSvNameDrawerOpened(false)}
                        title='Select Insurance Provider'
                    >
                        <div className='px-4 py-6'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setSvName(newValue);
                                }}
                                state={state}
                                className="rounded-xl w-full text-center"
                            >
                                {insuranceProviders.map((provider) => (
                                    <BringzzRadio
                                        key={provider}
                                        value={provider}
                                        className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400"
                                    >
                                        <div>{provider}</div>
                                    </BringzzRadio>
                                ))}
                            </BringzzRadioList>
                        </div>

                        <div className='text-center mb-12 px-4'>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setSvNameDrawerOpened(false)}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>

                    <BringzzInput
                        label="Name of Patient"
                        placeholder="Enter Patient Name"
                        tooltip="Full name as it appears on your prescription"
                        onChange={(e) => setPatientName(e.target.value)}
                    />

                    <div className="flex gap-4">
                        <div className="flex-1">
                            <BringzzInput
                                label="SV-Number"
                                placeholder="1234"
                                tooltip="Your social security number"
                                onChange={(e) => setSvNumber(e.target.value)}
                            />
                        </div>
                        <div className="flex-1">
                            <div className='space-y-[1px]'>
                                <BringzzText tag="h3">Birthday</BringzzText>
                                <BringzzDate
                                    placeholder="DD/MM/YYYY"
                                    format="dd/MM/yyyy"
                                    tooltip="Patient's date of birth"
                                    onChange={(newDate) => setBirthday(newDate)}
                                    mode={Mode.DAY}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                    </div>

                    <BringzzAccordion
                        title="Assured information"
                    >
                        <div className='space-y-3'>
                            <BringzzInput
                                label="Name of Patient"
                                placeholder="Enter Patient Name"
                                tooltip="Full name as it appears on your prescription"
                                onChange={(e) => setPatientName(e.target.value)}
                            />

                            <div className="flex gap-4">
                                <div className="flex-1">
                                    <BringzzInput
                                        label="SV-Number"
                                        placeholder="1234"
                                        tooltip="Your social security number"
                                        onChange={(e) => setSvNumber(e.target.value)}
                                    />
                                </div>
                                <div className="flex-1">
                                    <div className='space-y-[1px]'>
                                        <BringzzText tag="h3">Birthday</BringzzText>
                                        <BringzzDate
                                            placeholder="DD/MM/YYYY"
                                            format="dd/MM/yyyy"
                                            tooltip="Patient's date of birth"
                                            onChange={(newDate) => setBirthday(newDate)}
                                            mode={Mode.DAY}
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BringzzAccordion>

                    <BringzzInput
                        label="REZ-ID"
                        placeholder="Enter Receipt ID"
                        tooltip="Prescription identification number"
                        onChange={(e) => setRezId(e.target.value)}
                    />

                    <div className='space-y-[1px]'>
                        <BringzzText tag="h3">Validity Date</BringzzText>
                        <BringzzDate
                            placeholder="DD/MM/YYYY"
                            format="dd/MM/yyyy"
                            tooltip="Last date the prescription is valid"
                            onChange={(newDate) => setValidity(newDate)}
                            mode={Mode.DAY}
                            minDate={new Date()}
                        />
                    </div>

                    <div className='space-y-[1px]'>
                        <BringzzText tag="h3">Issue Date</BringzzText>
                        <BringzzDate
                            placeholder="DD/MM/YYYY"
                            format="dd/MM/yyyy"
                            tooltip="Date when the prescription was issued"
                            onChange={(newDate) => setIssueDate(newDate)}
                            mode={Mode.DAY}
                            maxDate={new Date()}
                        />
                    </div>
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default PrescriptionFormPage;
